import HttpClient from "@trustpayments/http-client";
import { Container } from "typedi";
import { ThreeDSecureFactory } from "@trustpayments/3ds-sdk-js";
import { ENVIRONMENT } from "../../environments/environment";
import { ConfigProvider } from "../../shared/services/config-provider/ConfigProvider";
import { ConfigService } from "../../shared/services/config-service/ConfigService";
import { GooglePaySdkProvider } from "../integrations/google-pay/google-pay-sdk-provider/GooglePaySdkProvider";
import { IGooglePaySdkProvider } from "../integrations/google-pay/google-pay-sdk-provider/IGooglePaySdkProvider";
import { PreventNavigationPopup } from "../message-subscribers/PreventNavigationPopup";
import { PaymentResultSubmitterSubscriber } from "../common-frames/PaymentResultSubmitterSubscriber";
import "../../shared/dependency-injection/ServiceDefinitions";
import { ApplePayClientInitializer } from "../../integrations/apple-pay/client/ApplePayClientInitializer";
import { IApplePayNamespace } from "../../integrations/apple-pay/client/models/IApplePayNamespace";
import { OfficialApplePaySession } from "../../integrations/apple-pay/client/services/session/OfficialApplePaySession";
import { GooglePayClientInitializer } from "../integrations/google-pay/google-pay-client-initializer/GooglePayClientInitializer";
import { PayPalClientInitializer } from "../../integrations/paypal/client/pay-pal-client-initializer/PayPalClientInitializer";
import { TokenizedCardClientInitializer } from "../../integrations/tokenized-card/client/TokenizedCardClientInitializer";
import { IPayPalInjector } from "../../integrations/paypal/client/IPayPalInjector";
import { OfficialPayPalNamespaceInjector } from "../../integrations/paypal/client/OfficialPayPalNamespaceInjector";
import { MessageBusPayPalTokenSource } from "../../integrations/paypal/client/MessageBusPayPalTokenSource";

import { MockedPayPalNamespaceInjector } from "../../integrations/paypal/client/pay-pal-mocks/MockedPayPalNamespaceInjector";
import { MessageBusPayPalJwtListener } from "../../integrations/paypal/client/MessageBusPayPalJwtListener";
import { MessageBusPayPalTokenPublisher } from "../../integrations/paypal/client/MessageBusPayPalTokenPublisher";
import { OfficialApplePayButtonFactory } from "../../integrations/apple-pay/client/services/button/OfficialApplePayButtonFactory";
import { MockedApplePayNamespace } from "../../integrations/apple-pay/client/mock/MockedApplePayNamespace";
import { DefaultApplePayEventBinder } from "../../integrations/apple-pay/client/services/payment/DefaultApplePayEventBinder";
import { MockedApplePayButtonFactory } from "../../integrations/apple-pay/client/mock/MockedApplePayButtonFactory";
import { InternalsMonitorGlobalActivityTracker } from "../../application/core/services/monitoring/InternalsMonitorGlobalActivityTracker";
import {
  APPLE_PAY_APPLE_PAY_EVENT_BINDER_TOKEN,
  APPLE_PAY_BUTTON_FACTORY_TOKEN,
  PAYAPAL_JWT_LISTENER_TOKEN,
  PAYPAL_TOKEN_PUBLISHER_TOKEN,
  PAYPAL_TOKEN_SOURCE_TOKEN,
} from "./InjectionTokens";
Container.set({
  id: ConfigProvider,
  factory: () => Container.get(ConfigService),
});
Container.set({ id: ThreeDSecureFactory, type: ThreeDSecureFactory });
Container.set({ id: IGooglePaySdkProvider, type: GooglePaySdkProvider });

/**
 * PayPal Dependencies Start Here
 */
Container.set({
  id: IPayPalInjector,
  type: ENVIRONMENT.PAYPAL.USE_UI_MOCK
    ? MockedPayPalNamespaceInjector
    : OfficialPayPalNamespaceInjector,
});

Container.set({
  id: PAYPAL_TOKEN_SOURCE_TOKEN,
  type: MessageBusPayPalTokenSource,
});

Container.set({
  id: PAYPAL_TOKEN_PUBLISHER_TOKEN,
  type: MessageBusPayPalTokenPublisher,
});

Container.set({
  id: PAYAPAL_JWT_LISTENER_TOKEN,
  type: MessageBusPayPalJwtListener,
});

/**
 * PayPal Dependencies End Here
 */
Container.import([
  ApplePayClientInitializer,
  ApplePayClientInitializer,
  GooglePayClientInitializer,
  PayPalClientInitializer,
  PaymentResultSubmitterSubscriber,
  PaymentResultSubmitterSubscriber,
  PreventNavigationPopup,
  PreventNavigationPopup,
  InternalsMonitorGlobalActivityTracker,
  TokenizedCardClientInitializer,
]);

if (ENVIRONMENT.testEnvironment) {
  Container.set({ id: HttpClient, type: HttpClient });
}

Container.set({
  id: APPLE_PAY_BUTTON_FACTORY_TOKEN,
  type: ENVIRONMENT.APPLEPAY.USE_UI_MOCK
    ? MockedApplePayButtonFactory
    : OfficialApplePayButtonFactory,
});

Container.set({
  id: APPLE_PAY_APPLE_PAY_EVENT_BINDER_TOKEN,
  type: DefaultApplePayEventBinder,
});

Container.set({
  id: IApplePayNamespace,
  type: resolveApplePayNamespaceType(ENVIRONMENT.APPLEPAY.USE_UI_MOCK),
});

function resolveApplePayNamespaceType(
  useMock: boolean,
): new (window: IWindow) => IApplePayNamespace {
  return useMock ? MockedApplePayNamespace : OfficialApplePaySession;
}
